import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ButtonIcon = ({ name }) => (
  <FontAwesomeIcon icon={["far", name]} className="btn-icon" />
);

/**
 * Button Component with color and background customization
 */
const Button = ({
  isCustomLogo,
  text,
  logo,
  color,
  background,
  visibility,
  iconFA,
  iconPosition = "start",
  onClick = () => { },
  className = "",
  disabled = false,
  type,
  title,
  display
}) => {
  const thisClassName = `btn btn-primary ${className}`;
  const buttonStyle = {
    color: color,
    background: background,
    visibility: visibility,
    display: display
  };

  const isCustom = isCustomLogo && logo;
  const isNothing = !isCustom && !iconFA && !text;

  if (isNothing) return null;

  return (
    <button
      className={thisClassName}
      style={buttonStyle}
      onClick={onClick}
      disabled={disabled}
      type={type}
      title={title}
    >
      {isCustom ? (
        <div>
          <img src={logo} alt="logo" className="btn-icon-custom" />
          <br />
        </div>
      ) : (
        <>
          {iconFA && iconPosition === "start" && <ButtonIcon name={iconFA} />}
          {text && <span>{text}</span>}
          {iconFA && iconPosition === "end" && <ButtonIcon name={iconFA} />}
        </>
      )}
    </button>
  );
};

Button.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
  background: PropTypes.string,
  visibility: PropTypes.string,

  /**
   * FontAwesome icon name, see `icon` prop in FontAwesomeIcon
   * (@fortawesome/react-fontawesome)
   */
  iconFA: PropTypes.string,
  iconPosition: PropTypes.oneOf(["start", "end"]),
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(["submit"])
};

export default Button;
